/* Copyright (C) Okahu Inc 2023-2024. All rights reserved. */

// Get current tenant's default time range from localStorage
export const getTenantTimeRange = (): string | null => {
  const tenantId = localStorage.getItem('currentTenantId');
  if (!tenantId) return null;

  const map = JSON.parse(localStorage.getItem('tenantTimeRangeMap') || '{}');
  return map[tenantId] || null;
};

// Set current tenant's default time range to localStorage
export const setTenantTimeRange = (value: string): void => {
  const tenantId = localStorage.getItem('currentTenantId');
  if (!tenantId) return;

  const map = JSON.parse(localStorage.getItem('tenantTimeRangeMap') || '{}');
  map[tenantId] = value;
  localStorage.setItem('tenantTimeRangeMap', JSON.stringify(map));

  // Trigger measures refresh
  window.dispatchEvent(
    new CustomEvent('tenantTimeRangeChanged', {
      detail: { tenantId, timeRange: value },
    })
  );
};
